export default __webpack_public_path__ + "static/media/FortisHeader2.aac08d15.png";